import { render, staticRenderFns } from "./ModalEditOptionChannels.vue?vue&type=template&id=7fa655d2"
import script from "./ModalEditOptionChannels.vue?vue&type=script&lang=js"
export * from "./ModalEditOptionChannels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports